import { Td, Tr, TableCellProps } from '@chakra-ui/react';

const BomColumn = (props: TableCellProps) => <Td textAlign="center" p={3} {...props} />;

const BomRow = ({
  partNumber,
  description,
  quantity,
  version,
}: {
  partNumber?: string;
  description?: string;
  quantity?: number;
  version?: number;
}) => (
  <Tr
    key={partNumber}
    sx={{
      h: 25,
      fontSize: 'sm',
      px: 6,
      bgColor: version === 1 ? 'white' : 'base2Colour.500',
    }}
  >
    <BomColumn>{partNumber}</BomColumn>
    <BomColumn>{description}</BomColumn>
    <BomColumn>{quantity}</BomColumn>
  </Tr>
);

export default BomRow;
